export let changeTheViewContextMenuOption = "F9uI5c";
export let densitySectionLabel = "hiupld";
export let messageHeightSectionLabel = "XIlakc";
export let multipleRowsLabel = "$HPmL";
export let autoSwitchRowStyleLabel = "q$sGje";
export default {changeTheViewContextMenuOption,densitySectionLabel,messageHeightSectionLabel,multipleRowsLabel,autoSwitchRowStyleLabel};